import { render, staticRenderFns } from "./product-item-list.vue?vue&type=template&id=e51d9a82"
import script from "./product-item-list.vue?vue&type=script&lang=js"
export * from "./product-item-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports